import * as React from 'react';
import { WithStyles } from '@material-ui/core/styles/withStyles';
import { Typography } from '@material-ui/core';
import { ExpansionPanelDetails } from '@material-ui/core';
import { QuestionDto } from '../../../pages/questionTypes';
import { observer } from 'mobx-react';
import MultilineText from '../../MultilineText';

interface Props {
  question: QuestionDto;
}

type LocalStyles =  'detailArea';


type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class TextQuestionPreview extends React.Component<PropsWithStyle, {}> {

  constructor(props: PropsWithStyle) {
    super(props);
  }

  public render() {
    const {question} = this.props;
    return (
        <ExpansionPanelDetails className={this.props.classes.detailArea} key={question.id + 'text-question-details'}>
          {
            question.description &&
            <div>
              <Typography>
                <MultilineText text={question.description}/>
              </Typography>
            </div>
          }
        </ExpansionPanelDetails>
    );
  }
}

export default TextQuestionPreview;
